import { Icon, IIconProps } from "native-base";
import * as React from "react";
import { Circle } from "react-native-svg";

const Bullet = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Circle cx="12" cy="12" r="3" fill="currentColor" />
  </Icon>
);

export default Bullet;
